'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _WixComponent2 = require('../../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _RangeInputWithLabelComposite = require('./RangeInputWithLabelComposite.scss');

var _RangeInputWithLabelComposite2 = _interopRequireDefault(_RangeInputWithLabelComposite);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FieldLabelAttributes = require('../../FieldLabelAttributes/FieldLabelAttributes');

var _FieldLabelAttributes2 = _interopRequireDefault(_FieldLabelAttributes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangeInputWithLabelComposite = function (_WixComponent) {
  _inherits(RangeInputWithLabelComposite, _WixComponent);

  function RangeInputWithLabelComposite(props) {
    _classCallCheck(this, RangeInputWithLabelComposite);

    var _this = _possibleConstructorReturn(this, (RangeInputWithLabelComposite.__proto__ || Object.getPrototypeOf(RangeInputWithLabelComposite)).call(this, props));

    _this.state = {
      hasFocusFirst: false,
      hasFocusLast: false
    };
    return _this;
  }

  _createClass(RangeInputWithLabelComposite, [{
    key: '_doKeyDown',
    value: function _doKeyDown(e) {
      var keys = {
        upArrow: 38,
        downArrow: 40
      };
      if (e.keyCode === keys.upArrow && !isNaN(e.target.value)) {
        e.preventDefault();
        e.target.value++;
      }
      if (e.keyCode === keys.downArrow && !isNaN(e.target.value)) {
        e.preventDefault();
        e.target.value--;
      }
    }
  }, {
    key: '_handleFocusFirst',
    value: function _handleFocusFirst() {
      this.setState({ hasFocusFirst: true });
    }
  }, {
    key: '_handleBlurFirst',
    value: function _handleBlurFirst() {
      this.setState({ hasFocusFirst: false });
    }
  }, {
    key: '_handleFocusLast',
    value: function _handleFocusLast() {
      this.setState({ hasFocusLast: true });
    }
  }, {
    key: '_handleBlurLast',
    value: function _handleBlurLast() {
      this.setState({ hasFocusLast: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames;

      var children = _react.Children.toArray(this.props.children);
      var rangeType = this.props.children[1].type.displayName;
      var label = children.length === 3 ? _react2.default.createElement(
        'div',
        { className: _RangeInputWithLabelComposite2.default.label },
        children[0],
        this.props.required || this.props.info || this.props.tooltip ? _react2.default.createElement(_FieldLabelAttributes2.default, { required: this.props.required, info: this.props.info, tooltip: this.props.tooltip }) : null
      ) : null;
      var firstInput = children.length === 3 ? children[1] : children[0];
      var lastInput = children.length === 3 ? children[2] : children[1];

      var additionalFirstInputProps = {
        // This is a hack for passing a class to be added to the <Input>/<DatePicker> element
        noRightBorderRadius: rangeType === 'DatePicker' ? _RangeInputWithLabelComposite2.default.firstDate : _RangeInputWithLabelComposite2.default.firstinput,
        onKeyDown: function onKeyDown(e) {
          return _this2._doKeyDown(e);
        },
        onFocus: function onFocus(e) {
          return _this2._handleFocusFirst(e);
        },
        onBlur: function onBlur(e) {
          return _this2._handleBlurFirst(e);
        }
      };

      var additionalLastInputProps = {
        // This is a hack for passing a class to be added to the <Input>/<DatePicker> element
        noLeftBorderRadius: rangeType === 'DatePicker' ? _RangeInputWithLabelComposite2.default.lastDate : _RangeInputWithLabelComposite2.default.lastinput,
        onKeyDown: function onKeyDown(e) {
          return _this2._doKeyDown(e);
        },
        onFocus: function onFocus(e) {
          return _this2._handleFocusLast(e);
        },
        onBlur: function onBlur(e) {
          return _this2._handleBlurLast(e);
        }
      };

      var inputWrapperClassNames = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _RangeInputWithLabelComposite2.default.inputs, true), _defineProperty(_classNames, _RangeInputWithLabelComposite2.default.hasFocusFirst, this.state.hasFocusFirst), _defineProperty(_classNames, _RangeInputWithLabelComposite2.default.hasFocusLast, this.state.hasFocusLast), _classNames));

      return _react2.default.createElement(
        'div',
        { className: _RangeInputWithLabelComposite2.default.wrapper },
        label,
        _react2.default.createElement(
          'div',
          { className: inputWrapperClassNames },
          _react2.default.cloneElement(firstInput, additionalFirstInputProps),
          _react2.default.cloneElement(lastInput, additionalLastInputProps)
        )
      );
    }
  }]);

  return RangeInputWithLabelComposite;
}(_WixComponent3.default);

RangeInputWithLabelComposite.propTypes = _extends({}, _WixComponent3.default.propTypes, {
  children: PropTypes.any,
  required: PropTypes.bool,
  info: PropTypes.string
});

RangeInputWithLabelComposite.displayName = 'RangeInputWithLabelComposite';

exports.default = RangeInputWithLabelComposite;